import { render } from "./UserVipLog.vue?vue&type=template&id=5258952c"
import script from "./UserVipLog.vue?vue&type=script&lang=js"
export * from "./UserVipLog.vue?vue&type=script&lang=js"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__